import { render, staticRenderFns } from "./AlcadasOC.vue?vue&type=template&id=e8e7778c&"
import script from "./AlcadasOC.vue?vue&type=script&lang=js&"
export * from "./AlcadasOC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports